import * as UserActions from 'actions/user';

export const startKeepAlive = () => {
  let state = {
    alive: false,
    interval: null,
    millis: 10000,
  };

  const startInterval = () => {
    state = {
      ...state,
      interval: setInterval(checkAlive, state.millis),
    };
    startListen();
  };

  const checkAlive = () => {
    if (state.alive) {
      UserActions.keepaliveSession();
    }

    // Reset state for next iteration
    resetAlive();
    startListen();
  };

  const resetAlive = () => {
    state = {
      ...state,
      alive: false,
    };
  };

  const startListen = (event = 'click') => {
    document.addEventListener(event, handleUserInteraction);
  };

  const endListen = (event = 'click') => {
    document.removeEventListener(event, handleUserInteraction);
  };

  const handleUserInteraction = () => {
    state = {
      ...state,
      alive: true,
    };
    endListen();
  };

  // Send KeepAlive signal on refresh
  UserActions.keepaliveSession();
  startInterval();
};
